import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class BillUseingModal extends Vue {
  @Prop() visible: Boolean = false
  
  handleOk(){
    this.$emit('cancel')
  }
  handleCancel(){
    this.$emit('cancel')
  }
  onChange(e){
    console.log(e)
  }

  render() {
    return (
      <a-modal
        title={this.$t('page_bill_settings_apply')}
        visible={this.visible}
        onOk={() => this.handleOk()}
        maskClosable={false}
        onCancel={() => this.handleCancel()}
      >
        <a-checkbox-group style="width:100%;" onChange={e => this.onChange(e)}>
          <a-row>
            <a-col span={8}><a-checkbox value={"A"}>A</a-checkbox></a-col>
          </a-row>
        </a-checkbox-group>
      </a-modal>
    )
  }
}